import React from "react";
import DiscoveryPage from "./components/DiscoveryPage";
import "./App.css";
import RestaurantHome from "./components/RestaurantHome";

function App() {
  if (window.location.pathname.replace(/\/$/, "") === "/discover")
    return <DiscoveryPage />;
  return <RestaurantHome />;
}

export default App;
